import React from 'react';
import {
  BackupTable,
  ManageAccounts,
  Adjust,
  Wifi,
  Lightbulb,
  Group,
  Schedule,
  ScreenLockLandscape,
  BatchPrediction,
  SportsSoccer,
  Contrast,
  Router
} from '@mui/icons-material';

const iconMap: Record<string, React.JSX.Element> = {
  '/lights_zones/': <Lightbulb />,
  '/trim_lights/': <Lightbulb />,
  '/groups/': <BatchPrediction />,
  '/schedules/': <Schedule />,
  '/scenes/': <ScreenLockLandscape />,
  '/game_day/': <SportsSoccer />,
  '/effects/': <Contrast />,
  '/connectivity/': <Router />,
  '/light_shows/': <Lightbulb />,
  '/light_shows_scenes/': <ScreenLockLandscape />
};

export const getIconModule = (path: string) => iconMap[path] || null;
